import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot } from '@angular/router';
import { ContentsCalculatorComponent } from '../pages/contents-calculator/contents-calculator.component';
import { NavButtonsService } from '../services/nav-buttons-service/nav-buttons.service';
import { HouseholdQuoteStateService } from '../services/household-quote-state-service/household-quote-state.service';
import { CalculatorService } from '../services/contents-calculator/calculator-service/calculator.service';
import { QuoteSteps } from '../models/enums/quote-steps';
import { routeNames } from '../app-routing-names';
import { StepService } from '../services/step-service/step.service';

@Injectable({
    providedIn: 'root'
})
export class QuickQuestionsGuard {
    private childRoutesCount: number = 0;

    constructor(public router: Router,
        private NavBtnService: NavButtonsService,
        public calcService: CalculatorService,
        private householdQuoteStateService: HouseholdQuoteStateService,
        private stepService: StepService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let requiredStep = route.data.step as number;
        let redirect = route.data.redirect as string;
        return this.isAllowedNavigate(requiredStep, redirect);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        this.childRoutesCount++;
        return this.canActivate(route, state);
    }

    canDeactivate(component: ContentsCalculatorComponent,
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
        nextState: RouterStateSnapshot): boolean {

        let currentNavigation = this.router.getCurrentNavigation();

        if (currentNavigation.trigger == 'popstate') {
            this.childRoutesCount--;
        }

        this.NavBtnService.skipRoutes(this.childRoutesCount);
        this.childRoutesCount = 0;
        return true;
    }

    canLoad(route: Route): boolean {
        this.childRoutesCount = 0;
        return true;
    }

    isAllowedNavigate(requiredStep: number, redirect: string = routeNames.OWN_RENT_PROPERTY): boolean {
        let currentNavigation = this.router.getCurrentNavigation();
        let currentStep = this.householdQuoteStateService.getCurrentStep();

        if (currentNavigation.trigger == 'popstate' && this.childRoutesCount > 1) {
            this.childRoutesCount -= 2;
        }

        if ((requiredStep !== QuoteSteps.quickQuestions && !currentStep) && (currentStep < requiredStep && this.stepService.quoteFormStep$.value < requiredStep)) {
            this.router.navigateByUrl(redirect);

            return false;
        }
        return true;
    }
}
